var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7c941c7a6071e86c02da895d720955d9.svg#q';
                    var viewUrl = 'sprites.7c941c7a6071e86c02da895d720955d9.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };